import { createFileRoute } from "@tanstack/react-router";
import Auth from "@/pages/Auth";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/auth/")({
  head: () => routeHead("/de/auth/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Auth />
  );
}
